import Siema from 'siema';

export default {
	_elements   : null,
	_sliders    : [],
	_autoPlayIDs: [],
	init() {
		this._elements = document.querySelectorAll('[data-slider]');
		if (!this._elements.length) {
			return;
		}
		Array.prototype.forEach.call(this._elements, (el, ind) => {
			const isMulti   = Boolean(el.children.length > 1);
			const autoPlay  = el.getAttribute('data-slider-auto-play');
			const draggable = el.getAttribute('data-slider-draggable');
			const UUID      = el.getAttribute('data-slider');
			this._sliders.push({
				isMulti      : isMulti,
				autoPlay     : autoPlay === 'false' ? false : isMulti,
				slideDuration: parseInt(el.getAttribute('data-slide-duration')),
				navElements  : document.querySelectorAll(`[data-slider-nav="${UUID}"]`),
				slider       : new Siema({
					selector : `[data-slider="${UUID}"]`,
					duration : 800,
					draggable: draggable === 'false' ? false : isMulti,
					easing   : 'ease',
					threshold: 60,
					loop     : isMulti,
					perPage	 : {
						0: 1,
						768: parseInt(el.getAttribute('data-slides-per-page')),
					},
					onChange : this._onChange.bind(this, ind)
				})
			});
			el.style.opacity = '1';
		});
		Array.prototype.forEach.call(this._sliders, (slider, ind) => {
			if (slider.autoPlay) {
				this._initAutoPlay(ind);
			}
			if (slider.navElements.length) {
				Array.prototype.forEach.call(slider.navElements, nav => {
					const direction = nav.getAttribute('data-slider-nav-direction');
					nav.addEventListener('click', e => {
						e.preventDefault();
						e.stopPropagation();
						if (direction === 'prev') {
							slider.slider.prev();
						} else if (direction === 'next') {
							slider.slider.next();
						}
					});
				});
			}
		});
	},
	reload() {
		if (this._elements.length) {
			Array.prototype.forEach.call(this._sliders, slider => {
				slider.slider.destroy();
			});
		}
		Array.prototype.forEach.call(this._autoPlayIDs, id => {
			this._stopAutoPlay(id);
		});
		this.init();
	},
	_onChange() {
		Array.prototype.forEach.call(this._sliders, (slider, ind) => {
			if (slider.autoPlay) {
				this._stopAutoPlay(ind);
				this._initAutoPlay(ind);
			}
		});
	},
	_initAutoPlay(id) {
		this._autoPlayIDs[id] = setTimeout(() => {
			this._sliders[id].slider.next();
		}, this._sliders[id].slideDuration);
	},
	_stopAutoPlay(id) {
		clearTimeout(this._autoPlayIDs[id]);
	}
};